import axiosInstance from './axios.service'
import BaseUrl from "./url.service"

const serverUrl = `${BaseUrl}/dealershipOwnerRoutes`


export const getAllOpportunities = async (query) => {
    return axiosInstance.get(`${serverUrl}/getDelearshipOpportunities?${query}`)
}

export const getById = async (id) => {
    return axiosInstance.get(`${serverUrl}/getDelearshipOpportunities/${id}`)
}

export const deleteOpportunityById = async (id) => {
    return axiosInstance.delete(`${serverUrl}/dealership-owners/${id}`)
}

export const AddOpportunity = async (obj) => {
    return axiosInstance.post(`${serverUrl}/createDealershipOpportunity`, obj)
}
export const updateOpportunityById = (id, formData) => {
  return axiosInstance.put(`${serverUrl}/dealership-owners/${id}`, formData)
}
  